<template>
  <header class="header-desktop">
    <div class="section__content section__content--p30">
      <div class="container-fluid">
        <div class="header-wrap">
          <form class="form-header" action method="POST"></form>
          <div @click="logout" class="btn btn-link">Logout</div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import AdminService from "@/services/AdminService";

export default {
  name: "HeaderDesktop",

  methods: {
    logout() {
      AdminService.logout().then(response => {
        if (response.status == 200) {
          localStorage.removeItem("token");
          this.$store.dispatch("setAdmin", null);
          this.$router.push("/login");
        }
      });
    }
  }
};
</script>
